module.exports = __webpack_public_path__ + "img/symbol_0.160bba1b.png";